/**
 * RevealCard - the GM's ask before a hidden figure's act reaches a player (plan design-gaps, Z4; the session page).
 *
 * "GUNNER ACTS, HIDDEN - on Castiel. Reveal them to the table?" with Reveal and Keep hidden, among the bars over
 * the map: a card, not a dialog, so the table does not stop for it. Its bar runs down the wait, and when it runs
 * out Keep hidden is taken (hooks/useRevealProposal; ruled 2026-10-13). Only the GM ever holds an ask; nothing
 * when there is none.
 *
 * @param {object} props
 * @param {object|null} props.ask - useRevealProposal's `revealAsk`
 */
import common from '../styles/common.module.css';
import styles from '../styles/RevealCard.module.css';

export default function RevealCard({ ask }) {
  if (!ask) return null;
  return (
    <div className={styles.card} role="alertdialog" aria-label="Reveal the hidden figure?" data-testid="reveal-card">
      <h5 className={styles.head}>{ask.actor} acts, hidden</h5>
      <p className={styles.line}>
        {ask.target ? `On ${ask.target}. ` : ''}This reaches a player: reveal them to the table? Wait, and they stay
        hidden.
      </p>
      <div className={styles.wait} aria-hidden="true" />
      <div className={styles.buttons}>
        <button
          type="button"
          className={common.btnDodge}
          data-testid="reveal-card-reveal"
          onClick={() => ask.answer('reveal')}
        >
          Reveal {ask.actor}
        </button>
        <button
          type="button"
          className={common.btnSmall}
          data-testid="reveal-card-keep"
          onClick={() => ask.answer('veiled')}
        >
          Keep hidden: act as {ask.alias}
        </button>
      </div>
    </div>
  );
}
